import axios from "axios";
import { ApiException } from "../ApiException";

const consultarCep = async (cep) => {
    try {
        const data = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
        return data;
    } catch(error) {
        return new ApiException(error.message || "Erro ao consultar ao adicionar lojista");
    }
}

export const CepService = {
    consultarCep
};